import { createAction } from 'redux-actions';
import { batchActions } from 'redux-batched-actions';

import authService from "../../domain/services/AuthService";
import { setProcessingLoaderVisibility } from "../../../layout/store/actions";
import { SignInEmailErrorCodeEnum } from '../../domain/enums/SignInEmailErrorEnum';

const namespace = 'AUTH_BY_GOOGLE';

export const googleSignInRequest = createAction(`${namespace}/GOOGLE_SIGN_IN_REQUEST`);
export const googleSignInSuccess = createAction(`${namespace}/GOOGLE_SIGN_IN_SUCCESS`);
export const googleSignInFailed = createAction(`${namespace}/GOOGLE_SIGN_IN_FAILED`);

export const resetGoogleErrors = createAction(`${namespace}/RESET_GOOGLE_ERRORS`);

export function loginByGoogle() {
  return (dispatch, getState) => {

    dispatch(batchActions([
      googleSignInRequest(),
      setProcessingLoaderVisibility(true)
    ]));

    authService.signWithGoogle()
      // on success loader will hide in "onAuthStateChanged" callback
      .then((response) => {
        dispatch(googleSignInSuccess())
      })
      .catch((error) => {
        if (error.code === SignInEmailErrorCodeEnum.EmailAlreadyInUse) {
          new Noty({
            type: 'error',
            text: error.message,
            layout: 'center',
            timeout: 3000
          });
        }
        dispatch(batchActions([
          googleSignInFailed(error),
          setProcessingLoaderVisibility(false)
        ]));
      })
  };
}